<!--
TODO - get the gallery working as per
https://mdbootstrap.com/docs/vue/advanced/lightbox/


get a proper more info page setup like
https://www.mackoy.co.uk/projects/emsworth-hampshire/

-->
<template>
	<mdb-container fluid>
		<mdb-row>
			<mdb-col col="1"></mdb-col>
			<mdb-col sm="6">
				<p class="projectTitle">{{ projectData.Title }}</p>
			</mdb-col>
			<mdb-col col="1"></mdb-col>
		</mdb-row>
	
		<mdb-row>
			<mdb-col col="1" class="d-none d-lg-block"/>
			
			<mdb-col md="2">
				<h4 class="projectsTitle">Project Details</h4>
				<p>{{ projectData.Details }}</p>
				<img :src="require(`@/assets/Customers/${projectData.CustomerLogo.url}`)" :alt="projectData.CustomerLogo.alt" width="20%"/>
			</mdb-col>

			<mdb-col md="4">
				<!-- 3 images	 -->
				<gallery :images="formatedImages" :index="index" @close="index = null"></gallery>

				<span v-if="projectData.Images.length == 3">
						<mdb-row>
							<mdb-col>
								<img class="img-fluid projectImage image" @click="index = 0" :src="require(`@/assets/Projects/${projectData.Images[0].url}`)" :alt="projectData.Images[0].alt" />
								<img class="img-fluid projectImage mt-4 image" @click="index = 1" :src="require(`@/assets/Projects/${projectData.Images[1].url}`)" :alt="projectData.Images[1].alt" />
							</mdb-col>
							<!-- expecting third image to be vertical -->
							<mdb-col>
								<img class="img-fluid projectImage image" @click="index = 2" :src="require(`@/assets/Projects/${projectData.Images[2].url}`)" :alt="projectData.Images[2].alt" />
							</mdb-col>
						</mdb-row>
				</span>


				<!-- 4 images	 -->
				<span v-else-if="projectData.Images.length == 4">
						<mdb-row>
							<mdb-col>
								<img class="img-fluid projectImage image" @click="index = 0" :src="require(`@/assets/Projects/${projectData.Images[0].url}`)" :alt="projectData.Images[0].alt" />
							</mdb-col>
							<mdb-col>
								<img class="img-fluid projectImage image" @click="index = 1" :src="require(`@/assets/Projects/${projectData.Images[1].url}`)" :alt="projectData.Images[1].alt" />
							</mdb-col>
						</mdb-row>	

						<mdb-row class="mt-4">
							<mdb-col>
								<img class="img-fluid projectImage image" @click="index = 2" :src="require(`@/assets/Projects/${projectData.Images[2].url}`)" :alt="projectData.Images[2].alt" />
							</mdb-col>
							<mdb-col>
								<img class="img-fluid projectImage image" @click="index = 3" :src="require(`@/assets/Projects/${projectData.Images[3].url}`)" :alt="projectData.Images[3].alt" />
							</mdb-col>
						</mdb-row>
				</span>

				<span v-else>
					<img v-for="image in projectData.Images"
							:key="image.alt"
							:src="require(`@/assets/Projects/${image.url}`)"
							:alt="image.alt"
							width="200"
							class="image"
						/>
				</span>

			</mdb-col>


			<mdb-col>
				<l-map :zoom="zoom" :center="center">
					<l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
					<l-marker :lat-lng="marker"></l-marker>       
				</l-map>
			</mdb-col>

			
			<mdb-col col="1" class="d-none d-lg-block"/>

		</mdb-row>
	</mdb-container>
</template>

<script>
import VueGallery from 'vue-gallery';
import { mdbContainer, mdbRow, mdbCol } from 'mdbvue';
import {LMap, LTileLayer, LMarker} from 'vue2-leaflet';
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'

export default {
    name: 'Project',
	props: {
	  projectData: Object,
	},
    components: {
      mdbContainer,
      mdbRow,
      mdbCol,
	  'gallery': VueGallery,
	  'l-map' : LMap,
	  'l-tile-layer' : LTileLayer,
	  'l-marker' : LMarker
    },
	data: function () {
      return {
        index: null,
				zoom: 13,
        center: [this.projectData.ProjectLatitude, this.projectData.ProjectLongitude],
        url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        marker: L.latLng(this.projectData.ProjectLatitude, this.projectData.ProjectLongitude),
	  }
	},
	computed: {
		formatedImages () {
			let updatedPaths = []
			for(var i=0; i < this.projectData.Images.length; i++) {
				updatedPaths.push(require("@/assets/Projects/" + this.projectData.Images[i].url))
			}
			return updatedPaths
		}
	}
}
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Fjalla+One&display=swap');

/* https://github.com/blueimp/Gallery#options */
.image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
}

.next {
	color: white !important;
	opacity: 0.75 !important;
}
.next:hover {
	color: white !important;
	opacity: 1 !important;
}

.prev {
	color: white !important;
	opacity: 0.75 !important;
}

.prev:hover {
	color: white !important;
	opacity: 1 !important;
}

.close {
	color: white !important;
	opacity: 75% !important;
}

.close:hover {
	color: white !important;
	opacity: 1 !important;
}

#projectBanner {
	background-color: #507195
}

#projectDescription{
	text-transform: uppercase;
	font-size: 20px;
	font-family: 'Fjalla One';
	font-weight: 700;

}

#projectSum {
	color: #dde4ea;
	font-family: 'Fjalla One';
}

.ashimage {
	position: absolute;
	right: 0;
}

</style>